import deleteIconImg from '../components/Images/delete.png'
import editIconImg from '../components/Images/edit.png'
import facebookImg from '../components/Images/facebook.png'
import gTopArrowImg from '../components/Images/gTopArrow.png'
import instaImg from '../components/Images/insta.png'
import oDownArrowImg from '../components/Images/oDownArrow.png'
import redditImg from '../components/Images/reddit.png'
import tiktokImg from '../components/Images/tiktok.png'
import youtubeImg from '../components/Images/youtube.png'
import profileImg from '../components/Images/profile.png'
import fPost from '../components/Images/fPost.png'
import iPost from '../components/Images/iPost.png'
import yPost from '../components/Images/yPost.png'
import heart from '../components/Images/heart.png'
import retweet from '../components/Images/retweet.png'
import gCheck from '../components/Images/gCheck.png'
import wRightArrow from '../components/Images/wRightArrow.png'
import wYoutube from '../components/Images/wYoutube.png'
import gProfile from '../components/Images/gProfile.png'
import bYoutube from '../components/Images/bYoutube.png'
import bInsta from '../components/Images/bInsta.png'
import bFacebook from '../components/Images/bfacebook.png'
import bReddit from '../components/Images/bReddit.png'
import Clipboard from '../components/Images/Clipboard.svg'
import check from '../components/Images/check.svg'

export const Icons = {
  delete: deleteIconImg,
  edit: editIconImg,
  facebook: facebookImg,
  gTopArrow: gTopArrowImg,
  insta: instaImg,
  oDownArrow: oDownArrowImg,
  reddit: redditImg,
  tiktok: tiktokImg,
  youtube: youtubeImg,
  profile: profileImg,
  fPost,
  iPost,
  yPost,
  heart,
  retweet,
  gCheck,
  wRightArrow,
  wYoutube,
  gProfile,
  bYoutube,
  bInsta,
  bFacebook,
  bReddit,
  Clipboard,
  check,
} as const

export type IconsType = typeof Icons
